<template>
  <v-row justify="center">
    <v-dialog
        v-model="percoModal"
        persistent
        max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Fetch perco data</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="6"
              >
                <v-menu
                    v-model="showFromDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formatDate(fromDate)"
                        label="From date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="fromDate"
                      @input="showFromDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="6"
              >
                 <v-menu
                    v-model="showToDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formatDate(toDate)"
                        label="To date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="toDate"
                      @input="showToDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="handleCloseClick"
          >
            Close
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="handleFetchClick"
          >
            Fetch
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from "moment";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "StationFetchPercoDataModal",
  computed: {
      ...mapState('probe', ['percoModal', 'activeProbe'])
  },
  beforeDestroy() {
    this.setPercoModal(false);
  },
  data() {
    return {
      fromDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      toDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      showFromDateMenu: false,
      showToDateMenu: false,
    }
  },
  mounted() {
    if (this.activeProbe.locations.length > 0) {
      let locations = this.activeProbe.locations;
      if (locations[locations.length - 1].start_date) {
        this.fromDate = locations[locations.length - 1].start_date;
      }
    }
  },
  methods: {
    ...mapMutations('probe', ['setPercoModal']),
    ...mapActions('probe', ['fetchProbePercoData']),
    async handleCloseClick() {
      await this.setPercoModal(false);
    },
    async handleFetchClick() {
      const payload = {
        probe_id: this.activeProbe.id,
        from_date: this.fromDate,
        to_date: this.toDate
      }
      await this.fetchProbePercoData(payload);
      await this.setPercoModal(false);
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('DD.MM.YYYY')
      }
      return '-'
    },
  }
}
</script>

<style scoped>

</style>